import type { ApplicationFormState } from '../types'
import { canRegisterApplication } from '../utils/validation'
import { useApplicationFormSubmitHandlers } from './registration/useApplicationFormSubmitHandlers'
import { useApplicationFormValidationActions } from './registration/useApplicationFormValidationActions'

type UseApplicationFormRegistrationArgs = {
  getAddressParts: () => {
    city: string
    state: string
    zipCode: string
  }
  state: ApplicationFormState
}

export function useApplicationFormRegistration({
  getAddressParts,
  state
}: UseApplicationFormRegistrationArgs) {
  const canRegister = canRegisterApplication(state.formData)
  const { handleRegister } = useApplicationFormSubmitHandlers({
    canRegister,
    getAddressParts,
    state
  })
  const { validateAndRegister } = useApplicationFormValidationActions({
    handleRegister,
    state
  })

  return {
    canRegister,
    validateAndRegister
  }
}
